module.exports = __webpack_public_path__ + "img/img-5.37f99eb8.png";